/* eslint-disable no-console */
import { call, put, takeLeading, select } from 'redux-saga/effects'

import fetchIpAddress from 'utils/ip-address'
import api from './api'
import actions from './actions'
import { getQuoteToken } from './selectors'

function* fetchTremendousRedemptionOptions({ payload }) {
  const { callback } = payload

  let isSuccess = false
  try {
    const result = yield call(api.fetchTremendousRedemptionOptions)
    yield put(actions.fetchTremendousRedemptionOptions.success(result))
    isSuccess = true
  } catch (err) {
    console.error('[Redemptions] fetchTremendousRedemptionOptions:', err)
    yield put(actions.fetchTremendousRedemptionOptions.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

function* fetchCryptoRedemptionOptions() {
  try {
    const result = yield call(api.fetchCryptoRedemptionOptions)
    yield put(actions.fetchCryptoRedemptionOptions.success(result))
  } catch (err) {
    console.error('[Redemptions] fetchCryptoRedemptionOptions:', err)
    yield put(actions.fetchCryptoRedemptionOptions.failure())
  }
}

function* requestCryptoRedemptionQuote({ payload }) {
  const { crypto, callback } = payload

  let isSuccess = false
  try {
    const result = yield call(api.requestCryptoRedemptionQuote, crypto)
    yield put(actions.requestCryptoRedemptionQuote.success(result))
    isSuccess = true
  } catch (err) {
    console.error('[Redemptions] requestCryptoRedemptionQuote:', err)
    yield put(actions.requestCryptoRedemptionQuote.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

function* requestTremendousRedemption({ payload }) {
  const { amount, destination, recaptchaToken, callback } = payload

  let isSuccess = false
  let errorResponse = null
  try {
    const { ipAddress } = yield call(fetchIpAddress)
    yield call(api.requestTremendousRedemption, amount, destination, recaptchaToken, ipAddress)
    yield put(actions.requestTremendousRedemption.success())
    isSuccess = true
  } catch (err) {
    console.error('[Redemptions] requestTremendousRedemption:', err)
    errorResponse = err?.response?.data ?? null
    yield put(actions.requestTremendousRedemption.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, errorResponse)
    }
  }
}

function* requestExternalRedemption({ payload }) {
  const { amount, destination, recaptchaToken, callback } = payload

  let isSuccess = false
  let errorResponse = null
  try {
    const { ipAddress } = yield call(fetchIpAddress)
    yield call(api.requestExternalRedemption, amount, destination, recaptchaToken, ipAddress)
    yield put(actions.requestExternalRedemption.success())
    isSuccess = true
  } catch (err) {
    console.error('[Redemptions] requestExternalRedemption:', err)
    errorResponse = err?.response?.data ?? null
    yield put(actions.requestExternalRedemption.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, errorResponse)
    }
  }
}

function* requestSharesRedemption({ payload }) {
  const { amount, recaptchaToken, callback } = payload

  let isSuccess = false
  let response = null
  try {
    const { ipAddress } = yield call(fetchIpAddress)
    response = yield call(api.requestSharesRedemption, amount, recaptchaToken, ipAddress)
    yield put(actions.requestSharesRedemption.success())
    isSuccess = true
  } catch (err) {
    console.error('[Redemptions] requestSharesRedemption:', err)
    response = err?.response?.data ?? null
    yield put(actions.requestSharesRedemption.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, response)
    }
  }
}

function* requestCryptoRedemption({ payload }) {
  const { amount, walletAddress, recaptchaToken, callback } = payload

  const cryptoQuoteToken = yield select(getQuoteToken)
  const { ipAddress } = yield call(fetchIpAddress)

  const requestPayload = {
    amount,
    quote_token: cryptoQuoteToken,
    crypto_address: walletAddress,
    recaptcha_token: recaptchaToken,
    ip_address: ipAddress,
  }

  let isSuccess = false
  let errorResponse = null
  try {
    yield call(api.requestCryptoRedemption, requestPayload)
    yield put(actions.requestCryptoRedemption.success())
    isSuccess = true
  } catch (err) {
    console.error('[Redemptions] requestCryptoRedemption:', err)
    errorResponse = err?.response?.data ?? null
    yield put(actions.requestCryptoRedemption.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, errorResponse)
    }
  }
}

function* main() {
  yield takeLeading(actions.fetchTremendousRedemptionOptions.INIT_TYPE, fetchTremendousRedemptionOptions)
  yield takeLeading(actions.fetchCryptoRedemptionOptions.INIT_TYPE, fetchCryptoRedemptionOptions)
  yield takeLeading(actions.requestTremendousRedemption.INIT_TYPE, requestTremendousRedemption)
  yield takeLeading(actions.requestExternalRedemption.INIT_TYPE, requestExternalRedemption)
  yield takeLeading(actions.requestSharesRedemption.INIT_TYPE, requestSharesRedemption)
  yield takeLeading(actions.requestCryptoRedemption.INIT_TYPE, requestCryptoRedemption)
  yield takeLeading(actions.requestCryptoRedemptionQuote.INIT_TYPE, requestCryptoRedemptionQuote)
}

export default {
  main,
  fetchTremendousRedemptionOptions,
  fetchCryptoRedemptionOptions,
  requestTremendousRedemption,
  requestExternalRedemption,
  requestSharesRedemption,
  requestCryptoRedemptionQuote,
  requestCryptoRedemption,
}
